import React, { useState } from 'react';
import classNames from 'clsx';
import ChevronDown from 'mdi-material-ui/ChevronDown';

import { QuestionAndAnswersEnum } from 'app/shared/enums';
import { Icon, IconsEnum } from 'app/components/Icon';
import { SafeHtml } from 'app/components/SafeHtml';
import { sections, topBoxes } from './QuestionsAndAnswersCepikForm.data';
import { useStyles } from './QuestionsAndAnswersCepikForm.styles';
import { BackToTopButton } from 'app/components/BackToTopButton';

function QuestionsAndAnswersCepikForm() {
  const classes = useStyles();
  const [openSections, setOpenSections] = useState<Set<number>>(
    new Set(sections.map((_, index) => index))
  );

  const handleToggleSection = (sectionIdx: number) => {
    setOpenSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(sectionIdx)) {
        newSet.delete(sectionIdx);
      } else {
        newSet.add(sectionIdx);
      }
      return newSet;
    });
  };

  return (
    <>
      <div className={classes.root} id={'questionsAndAnswersSection'}>
        <div className={classes.topSection}>
          <span className={classes.topTitle}>
            {QuestionAndAnswersEnum.GoodYouChooseMubi}
          </span>
          <div className={classes.topSubtitle}>
            {QuestionAndAnswersEnum.JoinDriversWithMubiInsurance}
          </div>
          <div className={classes.topBoxesRow}>
            {topBoxes.map((box) => (
              <div className={classes.topBox} key={box.title}>
                <div className={classes.topBoxTitle}>
                  <Icon
                    name={IconsEnum.CheckCircle}
                    className={classes.topBoxIcon}
                  />
                  {box.title}
                </div>
                <div className={classes.topBoxDesc}>{box.desc}</div>
              </div>
            ))}
          </div>
        </div>
        <div id={'questionsAndAnswersSectionMobile'}>
          {sections.map((section, sectionIdx) => {
            const isOpen = openSections.has(sectionIdx);
            return (
              <div className={classes.accordion} key={section.title}>
                <button
                  onClick={() => handleToggleSection(sectionIdx)}
                  aria-expanded={isOpen}
                  type="button"
                  className={classes.accordionSummary}
                >
                  <SafeHtml
                    html={section.title}
                    className={classes.sectionTitle}
                    component={'h2'}
                  />
                  <span
                    className={classNames(classes.arrow, {
                      [classes.arrowOpen]: isOpen,
                    })}
                  >
                    <ChevronDown />
                  </span>
                </button>
                {isOpen && (
                  <div className={classes.sectionContent}>
                    {(section.questions as Array<{
                      question: string;
                      answer: string;
                      tag?: string;
                    }>).map((q) => (
                      <div className={classes.qaItem} key={q.question}>
                        {q.tag === 'h3' ? (
                          <SafeHtml
                            html={q.question}
                            className={classes.question}
                            component={'h3'}
                          />
                        ) : (
                          <SafeHtml
                            html={q.question}
                            className={classes.question}
                            component={'h2'}
                          />
                        )}
                        <SafeHtml
                          html={q.answer}
                          className={classes.answer}
                          component={'div'}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className={classes.backToTop}>
        <BackToTopButton />
      </div>
    </>
  );
}

export default QuestionsAndAnswersCepikForm;
